__turbopack_context__.v({
  "footer": "footer-module-scss-module__9zPxoW__footer",
  "social": "footer-module-scss-module__9zPxoW__social",
});
